import React from 'react'
import { getApplicationDrilldownRoute, getServerDrilldownRoute } from '../route'
import { css, cx } from '@emotion/css'
import { Link } from '@contrast-security-inc/design-system-typography'

export interface RouteToAppLinkProps {
  readonly organizationID: string
  readonly applicationID: string
  readonly children: React.ReactNode
  readonly truncate?: boolean
  readonly className?: string
}

function getRouteToAppLink(linkType: string) {
  return function RouteToAppLink({
    organizationID,
    applicationID,
    children,
    truncate = false,
    className
  }: RouteToAppLinkProps) {
    return (
      <Link
        color={linkType === 'grid' ? 'neutral100' : 'turquoise90'}
        className={cx(
          className,
          truncate &&
            css`
              display: block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              word-wrap: normal;
            `
        )}
        href={getApplicationDrilldownRoute(organizationID, applicationID)}
        children={children}
      />
    )
  }
}

export interface RouteToServerLinkProps {
  readonly organizationID: string
  readonly serverID: string
  readonly children: React.ReactNode
}

function getRouteToServerLink() {
  return function RouteToServerLink({
    organizationID,
    serverID,
    children
  }: RouteToServerLinkProps) {
    return (
      <Link
        color="neutral100"
        href={getServerDrilldownRoute(organizationID, serverID)}
        children={children}
      />
    )
  }
}

export const RouteToAppLink = getRouteToAppLink('standard')
export const GridRouteToAppLink = getRouteToAppLink('grid')
export const GridRouteToServerLink = getRouteToServerLink()
